import { Pagination, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useCallback } from "react";

const PaginationComponent = ({
    totalItems,
    itemsPerPage=6,
    activePage,
    onPageChange
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const handleChange = useCallback((event, value) => {
        onPageChange(value - 1);
    }, [onPageChange]);

    return (
        <>
            <Stack 
                spacing={2}
                py={{xs: 3, md: 5}}
            >
                <Pagination 
                    count={Math.ceil(totalItems/itemsPerPage)}
                    page={activePage + 1}
                    onChange={handleChange}
                    shape="rounded" 
                    color="primary"
                    size={isMobile ? "small" : "large"}
                />
            </Stack>
        </>
    );
}

export default PaginationComponent;